import { handleActions } from "redux-actions"
import actions from "../actions"

// action type load
const { SET_SERVER_ERROR_POPUP } = actions.ConfigAction

// default state value
const initialState = {
  serverErrorPopup: { open: false, text: "" },
}

// handle action
export default handleActions(
  {
    [SET_SERVER_ERROR_POPUP]: (state, action) => ({
      ...state,
      serverErrorPopup: action.payload,
    }),
  },
  initialState
)
